import { MilestoneFilterStatusFlag } from '@bechtel/types';
import { t } from '@lingui/macro';

export const milestoneFlagList = [
  { id: 1, value: MilestoneFilterStatusFlag.BLOCKED, label: t`Blocked`, scope: [true, false] },
  { id: 2, value: MilestoneFilterStatusFlag.REJECTED, label: t`Rejected`, scope: [true, false] },
  //TODO: BE not implementing this search as per PO's request
  // { id: 3, value: MilestoneFilterStatusFlag.ALL_UNPLANNED, label: 'All Unplanned', scope: [true, false] },
  { id: 4, value: MilestoneFilterStatusFlag.EXPIRED, label: t`Expired`, scope: [true, false] },
];
